import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

import { CoreService } from "./../../base/core";
import { ServiceRoute } from "./../../base/service-route";
import { CommonHttpOption } from "./../../base/common-http-option";
import { IPlacement } from "src/app/interfaces/placement";

@Injectable({
  providedIn: "root"
})
export class PlacementService {
  constructor(private core: CoreService) { }

  list(
    filter: any,
    BranchEncryptId: string,
    page: number = 1,
    pageSize: number = 10
  ): Observable<any> {

    return this.core.get(
      ServiceRoute.placement.list + BranchEncryptId,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize, "Id", true)
        .append('Id', filter && filter.Id ? filter.Id : '')
        .append('FullName', filter && filter.FullName ? filter.FullName : '')
        .append('LevelInfoName', filter && filter.LevelInfoName ? filter.LevelInfoName : '')
        .append('NationalCode', filter && filter.NationalCode ? filter.NationalCode : '')
        .append('PackageId', filter && filter.PackageId ? filter.PackageId : '')
        .append('PlacementDateFrom', filter && filter.PlacementDateFrom ? filter.PlacementDateFrom : '')
        .append('PlacementDateTo', filter && filter.PlacementDateTo ? filter.PlacementDateTo : '')
        .append('PlacementReservationStatusId', filter && filter.PlacementReservationStatusId ? filter.PlacementReservationStatusId : '')
        .append('ReservedTimeFrom', filter && filter.ReservedTimeFrom ? filter.ReservedTimeFrom : '')
        .append('ReservedTimeTo', filter && filter.ReservedTimeTo ? filter.ReservedTimeTo : '')
        .append('TeacherName', filter && filter.TeacherName ? filter.TeacherName : '')
    );
  }

  getPlacementPersonList(_DateEnd: Date): Observable<any> {
    return this.core.get(
      ServiceRoute.placement.getPlacementPersonList,
      new CommonHttpOption().headers
    );
  }

  getById(id: number): Observable<any> {
    return this.core.get(
      ServiceRoute.placement.getById + id,
      new CommonHttpOption().headers
    );
  }

  setPlacement(data: IPlacement): Observable<any> {
    return this.core.post(
      ServiceRoute.placement.setPlacement,
      data,
      new CommonHttpOption().headers
    );
  }
}
